module.exports = __webpack_public_path__ + "static/img/player_head_5.3a89d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_5.jpg
// module id = 3D73
// module chunks = 1